const ca = {
  labels: {
    email: "Correu",
    password: "Contrasenya",
    name: "Nom",
    lastName: "Cognom",
    birthDate: "Data de naixement",
    timeZone: "Zona horària",
    city: "Ciutat",
    position: "Posició (CTO, employee, etc.)",
    newPassword: "Nova contrasenya",
    confirmPassword: "Confirmar contrasenya",
    biography: "Què vols que els altres usuaris sàpiguen de tu?",
    motto: "Motto (ex. Memento mori!!)",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    Spotify: "Spotify",
    web: "Pàgina web",
    message: "Escriu aquí el teu missatge",
    users: "Usuaris",
    user: "Usuaris",
    sound: "So",
    mic: "Micròfon",
    speakers: "Audio output",
    camera: "Càmera",
    sharing: "Compartint",
    spaceName: "Nom de l'espai",
    superSpaceName: "Nom del campus",
    multiWebinar:
      "Multiwebinar: Connectar els webinars de tots els espais en un sol",
    welcomeText: "Text de benvinguda",
    scene: "Escena",
    url: "Enllaç del vídeo",
    room: "Sala",
    wonderPointUrl: "URL del lloc web que apareixerà a la descripció",
    videoUrl: "Video fixat a la sala",
    lockVideoUrl: "Guardar el video a la sala",
    roomName: "Nom de la sala",
    posterName: "Nom del cartell",
    automaticWonderPoint: "Obriu automàticament en una pestanya nova.",
    reason: "Motiu",
    search: "Cercar",
    filters: "Filtrar",
    permissions: "Permisos",
    required: "Requerit",
    optional: "Opcional",
    description: "Descripció",
    comingBack: "Torno el",
    addEmails:
      "Afegeix correus electrònics per convidar usuaris, utilitzeu comes entre correus electrònics per afegir diversos usuaris",
    sentAt: "Enviat a les",
    invitedBy: "Convidat per",
    sentDate: "Data d'enviament",
    type: "Tipus",
    invitation: "Invitació",
    userInvitationType: "Usuari",
    invitedInvitationType: "Convidat",
    publicInvitationType: "Pública",
    customInvitationType: "Personalitzada",
    notFound: "Sense resultats",
    used: "Invitació usada",
    expireDate: "Data d'expiració",
    yes: "Usada",
    no: "Sense fer servir",
    publicUrl: "Url pública",
    maxCharacters: " (Caràcters màxims: {number})",
    withSound: "Amb so a les sales",
    withoutSound: "Sense so",
    hasSent: "Ha enviat",
    spaceType: "Tipus d'espai",
    creatorEmail: "Correu del creador",
    speedNetworkingDuration:
      "Durada de les trucades de Speed Networking (minuts)",
    generalChatEnable: "Habilitar xat general a l'espai",
    webinarChatEnable: "Habilitar xat als webinar de l'espai",
    returnToTheCity: "Aquest campus té accés a la ciutat",
    isPublic: "Aquest campus és públic per a tots els usuaris de nubi",
    chatNameDefault: "Xat de la sala",
    selectPlace: "On vols anar avui",
    addFavourite: "Afegir a favorits",
    removeFavourite: "Treure de favorits",
    language: "llengües ​​que dominen",
    itemsPerPage: "Elements per pàgina",
    titleProfileObboarding:
      "Emplena allò que vulguis que ALTRES AVATARS sàpiguen de tu.",
    profileObboarding:
      "Tu podràs copiar les seves dades i ells les teves. Deixa que sàpiguen com contactarte  després de conèixer-te.",
    permanentlyBlock: "Bloquejar pin permanentment",
    date: "Data",
    status: "Estat",
    showLogsOf: "Mostrar els registres de:",
    downloadCsv: "Descarregar CSV",
    from: "Des de",
    to: "A",
    spaces: "Espais",
    favoriteCampus: "Favorit",
    publicCampus: "Públic",
    otherCampus: "Campus al qual has estat convidat",
    disabledPassword:
      "La contrasenya està desactivada perquè el Multiwebinar està actiu",
    showText: "Escriu el text que es mostrarà (opcional)",
    poster: "Cartell",
    externalDashboardUrl: "URL extern per al dashboard",
    pin: "Pin",
    lowBandWidth: "Ample de banda baix",
    experienceTag: "En què tens més experiència?",
    learningTag: "Què t'agradaria aprendre/conèixer?",
    projectParticipationTag: "Projectes/Tipus de projectes en què ha participat?",
    addTag: "Afegir tag",
    showExperienceTag: "La meva experiència",
    showLearningTag: "M'agradaria aprendre/conèixer",
    showProjectParticipationTag: "Tipus de projectes en què he participat",
    activateNotepad: "Activar bloc de notes",
    notepadText: "Text bloc de notes",
    notepadRoom: "Bloc de notas de la sala",
    tags: "Tags",
    projects: "Projectes",
    knowledge: "Coneixements",
    experts: "Experts",
    contactAddress: "Adreça de contacte",
    phone: "Número de telèfon",
    link: "Enllaç d'interès",
    nationality: "Nacionalitat",
    personalInformation: "Informació Personal",
    gender: "Gènere",
    title: "Títol",
    groupMembers: "Membres del grup",
    moreInformation: "Més informació",
    spaceDefault: "Espai per defecte",
    reservePhysicalRoom: {
      imagen: "Imatge",
      physicalRooms: "Sales físiques",
      titlePlant: "Nom de la planta",
      floorPlanImage: "Imatge del pla",
      rooms: "Habitacions"
    },
    workExperiences: {
      title: "Experiència laboral",
      position: "Posició",
      startAt: "Data d'inici",
      endAtAt: "Data de finalització",
      company: "Companyia",
      companyType: "Tipus de companyia",
      description: "Descripció"
    },
    educations: {
      title: "Educació/Formació",
      educationalDegree: "Títol educatiu",
      startAt: "Data d'inici",
      finishAt: "Data de finalització",
      place: "Lloc",
      description: "Descripció"
    },
    languageSkills: {
      title: "Idiomes",
      language: "Idioma",
      listeningSkill: "Habilitat d'escolta",
      speakingSkill: "Habilitat per parlar",
      readingSkill: "Habilitat de lectura",
      writingSkill: "Habilitat per a l'escriptura"
    },
    digitalSkill: {
      title: "Habilitats digitals",
      informationProcessing: "Processament d'informació",
      communication: "Comunicació",
      contentCreation: "Creació de contingut",
      safety: "Seguretat",
      problemSolving: "Resolució de problemes"
    },
    otherSkill: {
      title: "Altres habilitats",
      communication: "Comunicació",
      organizationalOrManagement: "Organització o Gestió",
      teamWork: "Treball en equip",
      drivingLicense: "Llicència de conduir"
    },
    aboutYou: {
      title: "En què et consideres bo professionalment?",
      aboutYou: "El que pretenem és que quan un company necessiti resoldre algun problema, pugui comptar amb tu. Descriu tot allò en què creguis que et puguin consultar en cas d'ajuda.",
      message: "Escriu aquí",
    }
  },
  sidebar: {
    nubiiSpace: "nubi espai",
    usersInSpace: "Usuaris a l'espai",
    usersOnline: "Usuaris actius",
    noMatches: "No hi ha coincidències",
    messages: "Missatges",
    footer: {
      help: "Ajuda i Suport",
      legalTerms: "Termes legals",
      suggestions: "Idees?",
      defaultSpot: "Lloc per defecte",
    },
  },
  buttons: {
    logIn: "Entrar",
    send: "Enviar",
    save: "Desar",
    changeEmail: "Modificar correu",
    yes: "Si",
    no: "No",
    delete: "Eliminar",
    edit: "Editar",
    changeScene: "Canviar escenari",
    changeSpace: "Canviar d'espai",
    removeImagen: "Treure imatge del logo",
    removeImagenPoster: "Treure imatge del cartell",
    removeImageRoom: "Treure imatge de la sala",
    removeImagenScreenRoom: "Treure imatges de les pantalles de les sales",
    goToSpace: "Anar a aquest espai",
    cancel: "Cancel·lar",
    accept: "Acceptar",
    copy: "Copiar",
    copyUserInfo: "Copiar informació de l'usuari",
    next: "Següent",
    saveAndNext: "Desar i continuar",
    exitToCity: "Sortir a la ciutat",
    exitLeave: "Sortir de nubi",
    start: "Iniciar",
    backToNubii: "Tornar a nubi",
    imReady: "Estic llest!",
    skip: "Saltar aquest pas",
    letsGo: "Som-hi!",
    openUrl: "Obrir web",
    goTo: "Anar a la sala",
    openInTab: "Obrir en pestanya",
    iKnow: "D'acord, continuar",
    sendInfoUserEmail: "Enviar informació al meu correu",
    createSpace: "Crear espai",
    showProfile: "Veure perfil",
    enter: "Entrar",
    inviteMoreUsers: "Convidar més usuaris",
    sendNewMessage: "Enviar nou missatge",
    newMessage: "Nous missatges",
    backGame: "Tornar al joc",
    addSpace: "Afegir espai",
    inviteFriend: "Convidar un amic",
    showRooms: "Veure sales",
    enterInSpace: "Entrar a l'espai",
    showAll: "Veure tots",
    iNeedHelp: "Necessito ajuda...",
    deleteVideo: "Eliminar el vídeo",
    reload: "Actualitzar espais",
    unsubscribe: "Eliminar el meu compte",
    addUrl: "Afegeix un enllaç d'invitació",
    addVisitSpace: "Afegeix una visitia a un espai",
    clearChat: "Esborra el xat",
    programNotification: "Anuncis programats",
    usersGroup: "Grup d'usuaris",
    gotoCity: "Anar a la ciutat",
    retryPin: "Reenviar correu electrònic amb el número PIN",
    reloadNubi: "Recarregar",
    cleanAndStart: "Netejar i començar",
    sendReport: "Enviar reporti",
    congratulate: "Felicitar",
    notepad: "Bloc de notes",
    createSpaceOrHelp1: "Fes clic",
    createSpaceOrHelp2: "si vols crear el teu propi espai nubi. O contacta amb nosaltres ",
    createSpaceOrHelp3: "per ajudar-te a entendre com el fan servir els nostres clients.",
    here: "aquí",
    activate: "Activa",
    disable: "Desactivar",
    add: "Afegir",
    sendCurriculum: "Enviar currículum",
    updateCurriculum: "Actualitzar currículum",
    deleteCurriculum: "Esborrar currículum",
    createReserve: "Reserva creada amb èxit",
    updateReserve: "Reserva actualitzada amb èxit",
    removeReserve: "Reserva eliminada amb èxit",
    reserveRoomStart: "La sala està reservada",
    reserveRoomFinish: "La reserva ha finalitzat",
    saveAutoVideo: "Enregistrament desat correctament",
    createPhysicalPlantAndRoom: "Guardat correctament",
  },
  tooltips: {
    exit: "Sortir",
    spaceLabels: "Etiquetes",
    noWall: "Amagar parets",
    rotate: "Girar la càmera per actualitzar",
    disableNoWall: "En aquest espai no és possible utilitzar aquesta funcionalitat",
    mode3D: "Mode 3D",
    mode2D: "Mode 2D",
    activateCamera: "Activar càmera",
    deactivateCamera: "Desactivar càmera",
    activateMic: "Activar micròfon",
    deactivateMic: "Desactivar micròfon",
    shareScreen: "Compartir pantalla",
    unShareScreen: "Deixar de compartir",
    noWorkingTeams1: "MS Teams no permet compartir pantalla a aplicacions externes com nubi. Per fer-la servir, has ",
    noWorkingTeams2: "d'obrir nubi en una pestanya separada.",
    openChat: "Obrir xat",
    config: "Opcions",
    expand: "Expandir",
    contract: "Contreure",
    endCall: "Penjar trucada",
    enterCall: "Agafar trucada",
    editProfile: "Editar perfil",
    changeEmoji: "Reaccionar",
    busy: "Ocupat",
    call: "Disponible",
    cameraOptions: "Navegació",
    angles: "Angles",
    moveSpace: "Moure espai",
    zoom: "Zoom",
    centerMyAvatar: "Centrar el meu avatar",
    deleteInvitation: "Eliminar invitació",
    increaseInvitation: "Incrementar expiració",
    question: "Pregunta",
    sendQuestion: "Enviar aquest missatge com una pregunta",
    send: "Enviar",
    paperPlane: "Avió de paper",
    global: "Anuncis",
    pinnedBy: "Ancorat per",
    deletePinned: "Eliminar missatge ancorat",
    hide: "Amagar",
    callBack: "Tornar a la trucada",
    changePin: "Change PIN",
    textChangePin:
      "Aquesta sala està bloquejada permanentment des de l'administrador de l'espai",
    handUp: "Aixeca la mà",
    disableSpace: "L'espai està deshabilitat",
    deleteUser:
      "El teu usuari ha estat eliminat d'aquest espai. Només pots tornar a accedir si t'envien una invitació",
    disableUser:
      "Estàs banejat d'aquest espai. Posa't en contacte amb l'administrador.",
    imHome: "Estic a casa",
    imOffice: "Estic a l'oficina",
    diary: "Diari",
    buzz: "Buzz",
    mute: "Mutejar",
    noShowCam: "Apagar la càmera",
    changeLayout: "Canviar la disposició de la càmera",
    focusModeOn: "Activa el mode de concentració",
    focusModeOff: "Desactiva el mode de concentració",
    disableSpaceNubi: "L'espai ha estat deshabilitat per nubi",
    noSend: "Màxim de caràcters superat",
    searchFilters: "Filtres de cerca",
    filtersKnowledge: "En marcar aquesta opció es mostraran els usuaris amb aquesta experiència o que la vulguin aprendre",
    filtersProjects: "En marcar aquesta opció es mostraran els usuaris que participen al projecte",
    filtersExperts: "En marcar aquesta opció es mostraran els usuaris que siguin experts",
    deleteImage: "Treure imatge",
    addImage: "Afegir imatge",
    changeImage: "Canviar imatge",
    imageNotSaved: "Imatge no guardada",
    notCompatibleSafari: "Actualment no es pot compartir pantalla amb Safari",
    delete: "Esborrar",
    edit: "Editar",
    addUserAndDelete: "(Afegir / Esborrar) usuaris",
    dragUsers: "Pots traslladar els usuaris d'un camp a un altre arrossegant-los",
    disableGame: "Per activar el joc, es necessiten 3 jugadors en línia",
    activeGame: "En activar-se, el joc s'iniciarà",
    info: "Informació",
    save: "Guardar",
  },
  validatorError: {
    required: "El camp és requerit",
    email: "Has d'introduir un email vàlid",
    minLength:
      "La contrasenya ha de tenir com a mínim {count} caràcters de longitud",
    sameAs: "Les contrasenyes no coincideixen",
    invalidUrl: "Url invàlida, hauria de ser https://www.example.com",
  },
  notifications: {
    titles: {
      error: "ups!",
      success: "Fantàstic!",
      information: "Informació",
      requestPassword: "Sol·licitud de canvi de contrasenya",
    },
    descriptions: {
      userBan: "Usuari banejat amb èxit",
      userUpdate: "Perfil actualitzat amb èxit",
      spaceUpdate: "Espai actualitzat amb èxit",
      urlUpdate: "URL actualitzada correctament",
      emojiUpdate: "Emoji modificat amb èxit",
      avatarUpdate: "Avatar modificat amb èxit",
      petUpdate: "La mascota s'ha actualitzat correctament",
      roomUpdate: "Sala modificada amb èxit",
      posterUpdate: "Cartell modificat correctament",
      reasonUpdate: "Motiu actualitzat correctament",
      requestPassword:
        "S'ha enviat a {email} un correu per fer el canvi de contrasenya",
      resetPassword: "Contrasenya modificada ",
      deleteSpaceUser: "Usuari eliminat de l'espai",
      activeSpace: "L'espai ha estat activat satisfactòriament",
      activeSpace2:
        "Revisa el teu correu electrònic per última vegada per iniciar sessió al seu nou espai nubi",
      copyUrl: "URL copiada al porta-retalls",
      copyInfo: "Informació copiada al porta-retalls",
      confirmEmail: "Correu de confirmació enviat satisfactòriament",
      skip: "Ja ets un expert utilitzant nubi? si vols pots saltar aquest pas.",
      successActivateUser:
        "Usuari activat satisfactòriament, si ets usuari nou revisa la teva safata de correu, hem enviat les teves credencials per accedir a nubi, si no, pots ingressar directament des del login",
      sendInvitations: "Invitacions enviades satifastòriament",
      vacationOn: "Vacances actualitzades amb èxit",
      deleteInvitation: "Invitació eliminada satisfactòriament",
      increaseInvitation: "Temps d'expiració augmentat satisfactòriament.",
      recoveringPassword:
        "Hem enviat un correu electrònic per recuperar la contrasenya.",
      emailNotRegistered: "Aquest correu electrònic no està registrat a nubi.",
      waitSendRecoveryPassword:
        "Has d'esperar 5 minuts per tornar a sol·licitar la contrasenya.",
      muteExternalMic: "has silenciat el teu micròfon",
      stopExternalCam: "has apagat la teva càmera",
      buzzed: "t'ha fet buzz",
      recommendTurningOff:
        "Sembla que tens una amplada de banda molt baixa, et recomanem apagar la teva càmera",
      sendInfoEmail:
        "Informació de l'usuari enviada al seu correu satisfactòriament.",
      deleteSpace: "Espai eliminat satisfactòriament",
      createSpace: "Espai creat satisfactòriament",
      chatCopied: "Xat copiat al porta-retalls",
      pinnedMessage: "Missatge ancorat satisfactòriament",
      deletePinnedMessage: "Missatge ancorat eliminat satisfactòriament",
      disableUser: "Usuari deshabilitat satisfactòriament",
      assignedMyPlaceDefault:
        "Assignat el teu lloc per defecte. En endavant, quan entris a nubi o perdis momentàniament la connexió, aniràs directament a aquest lloc.",
      calendarUpdate: "El calendari s'ha actualitzat correctament",
      videoAudio: "Vídeo i Àudio actualitzat correctament",
      pinRequest:
        "Ja!, perfecte. t'hem enviat un email amb el teu número PIN d'accés d'UN ÚS NOMÉS. Si no ho veus en uns segons, revisa la teva carpeta d'SPAM.",
      pinErrorUserNotExist:
        "No tenim aquest correu electrònic com a usuari de nubi.",
      pinInvalidCredentials: "Correu electrònic o pin incorrecte.",
      pinRequestApin: "Demana un pin.",
      pinExceeded:
        "Has superat els intents d’inici de sessió amb aquest pin. Demana'n un de nou.",
      pinExpired: "El PIN ha caducat. Demana'n un de nou.",
      sendReport: "Report enviat satisfactòriament",
      autoplayCheckT: "S'ha detectat que el vídeo està configurat per començar a reproduir-se a partir d'un segon. L'autoplay només funciona quan el vídeo comença des del començament.",
      permissionError: "No es pot accedir als permisos",
      sendReportOk: "L'informe ha estat enviat",
      sendVoteOk: "El vot ha estat enviat",
      createGroup: "Grup creat",
      editGroup: "Grup editat",
      removeGroup: "Grup esborrat",
      createCurriculum: "Currículum creat amb èxit",
      updateCurriculum: "Currículum actualitzat amb èxit",
      deleteCurriculum: "Currículum eliminat amb èxit",
      hide: "Amaga",
      close: "Tanca",
    },
    newMessage: {
      title: "nubi missatge rebut",
      titleRoom: "nubi missatge rebut a la sala",
      body: "{name} t'ha enviat un missatge",
      bodyRoomGeneral: "{name} ha enviat un missatge al xat general",
      bodyRoomRoom: "{name} ha enviat un missatge al xat de la sala",
      bodyRoom: "{name} t'ha enviat un missatge",
      sendNewMessage: "Missatge enviat satifastòriament",
    },
    newConsoleMessage: "{name} ha enviat un anuncis",
    newPaperPlane: "{name} {lastName} t'ha enviat un avió de paper",
    newPaperPlaneApp:
      "{name} {lastName} està connectat des de nubi app, t'ha enviat un avió de paper des de {room}",
    sendNewPaperPlane: "Has enviat un avió de paper",
    sendBirthdayCake: "{name} {lastName} t'ha enviat un pastís d'aniversari",
    permissionsOk: {
      title: "Notificacions enceses",
      body: "Les notificacions es van activar amb èxit",
    },
    announcement: "Anunci",
    warningMessages: {
      youAreOnCall: "Ja estàs en una trucada.",
      isBusy: "{name} està ocupat.",
      triedCallYou: "{name} ha intentat trucar-te",
      emojiIsNotChangedOnCall:
        "No es pot canviar l'emoji si ets en una trucada.",
      stateIsNotChangedOnCall:
        "No es pot canviar l'estat si ets en una trucada.",
      connectionIsLow:
        "Hem detectat que la connexió és massa lenta, si us plau espera.",
      emailInSpace: "Ja existeix dins de l'espai",
      emailErrorGuest:
        "Els usuaris convidats no poden utilitzar la invitació d'usuari",
      nextMaintenance:
        "Hola. A nubi estem de reformes.<br>A les <b>{date}</b><br>hem de tancar les nostres instal·lacions durant uns minuts per acabar de pintar, penjar algun quadre i... fer de nubi la millor eina per a gent remota.",
    },
    errorMessages: {
      connectionIsLowRefresh:
        "No Hem pogut carregar els fitxers necessaris perquè nubi funcioni, potser el teu ordinador o la teva connexió tenen problemes. Fes",
      connectionIsLowRefreshClick: "clic aquí",
      connectionIsLowRefresh2: "per reintentar.",
      reasonUpdate: "No s'ha pogut actualitzar correctament el motiu",
      updatePerfil:
        "No s'ha pogut actualitzar el perfil. Si us plau, intenta-ho més tard",
      invalidCredentials: "Correu electrònic o contrasenya incorrecta",
      invalidPassword: "Contrasenya incorrecta",
      resetPassword:
        "No s'ha pogut modificar la contrasenya, si us plau torna a intentar-ho o posa't en contacte amb suport",
      pusherError:
        "Els canals no són compatibles amb el navegador, si us plau posa't en contacte amb suport.",
      spaceDisabled:
        "L'espai està deshabilitat, selecciona un altre o posa't en contacte amb suport.",
      spaceUserDisabled:
        "El teu usuari ha estat deshabilitat per l'administrador d'aquest espai.",
      userBanned: "L'usuari està deshabilitat. Posa't en contacte amb suport.",
      userDelete: "L'usuari ha estat esborrat. Posa't en contacte amb suport.",
      userSpaceBanned:
        "L'usuari està deshabilitat de l'espai, selecciona un altre o posa't en contacte amb suport.",
      spaceDelete:
        "L'espai ha estat esborrat, Si us plau, posa't en contacte amb suport.",
      spaceUserDelete:
        "L'usuari ha estat esborrat de l'espai, Si us plau, posa't en contacte amb suport.",
      invitationExpired: "La invitació és invàlida o ja ha caducat.",
      generateToken:
        "No hem pogut generar la invitació, torna-ho a intentar o posa't en contacte amb suport.",
      activateUser:
        "No hem pogut activar el teu compte, torna-ho a provar o posa't en contacte amb suport.",
      connectRoom:
        "No s'ha pogut connectar a la trucada, surt de la sala i torna-ho a provar",
      connectRoomError:
        "No s'ha pogut connectar a la trucada",
      connectOneToOneError:
        "L'altre usuari no és a la trucada",
      maxFileSize:
        "La mida de la imatge no està permesa, ha de ser menor a 2mb",
      fileType: "Només es permeten fitxers png, jpg i jpeg",
      linkCannotBeUsed: "L'enllaç no es pot fer servir amb aquest usuari",
    },
    noInternetConnection:
      "Estàs sense connexió, és possible que algunes funcions no estiguin disponibles",
    noChrome:
      "nubi està optimitzat per al navegador Google Chrome. Pots descarregar-lo gratis des d'AQUEST ENLLAÇ",
    noWebGl2:
      "nubi necessita que tinguis habilitat WebGl2 al teu explorador. Realitza AQUEST TEST per comprovar que estigui habilitat",
    noMobile:
      "Ara nubi només funciona a Google Chrome per a escriptori. Estem treballant perquè hi puguis accedir des de més plataformes.",
    downloadHere: "Descàrrega Google Chrome aquí",
    testHere: "Ingresa a el test aquí",
    iploneMobile: "Podeu descarregar l'app per a iPhone ",
    androidMobile: "Podeu descarregar l'app per a Android ",
    here: "aquí",
    devices: {
      title: "Dispositius no configurats",
      permissions:
        "Perquè altres usuaris puguin veure't i escoltar-te has de donar permisos d'accés a la teva càmera i micròfon al teu navegador. Fes clic a la icona en forma de cadenat a la barra de direccions, permet l'accés a àudio i càmera. Després d'això, has de recarregar la pàgina prement F5 a Windows o CMD+R a Mac",
      withoutDevices:
        "El teu navegador li diu a nubi que no ha trobat {devices}. Surt de la sala i vés a la configuració al menú superior dret de nubi per seleccionar algun de la llista. Si no en veus cap instal·lat, és que el teu navegador no ho detecta. Intenta verificar els permisos fent clic a la icona en forma de cadenat a la barra de direccions, permet l'accés a micròfon i càmera. Després d'això, has de recarregar la pàgina prement F5 a Windows o CMD+R a Mac. Si res d'això funciona, prova de reiniciar tot de zero.",
      devices1: "Cap càmera activa",
      devices2: "Cap micròfon actiu",
      devices3: "Cap càmera ni micròfon actiu",
      record: "enregistrement d'écran",
      permissionDenied: "Permisos denegats",
    },
    genericError: {
      genericError:
        "S'ha produït un error{code}, si us plau posa't en contacte amb suport.",
      genericErrorRetry:
        "S'ha produït un error, si us plau torna a intentar-ho.",
      genericErrorClientGraphic:
        "Hi ha hagut un error inesperat. En prémer 'Recarregar' reiniciem nubi. Si l'error persisteix, fes clic a 'Netejar i començar', que és més radical i hauràs de tornar a identificar-te o prémer a l'enllaç d'invitació.",
      genericErrorTeams:
        "Hi ha hagut un error inesperat. En prémer 'Recarregar' reiniciem nubi. Si l'error persisteix, si us plau posa't en contacte amb suport.",
      updateRoom:
        "S'ha produït un error al actualitzar la sala, si us plau posa't en contacte amb suport.",
      updateImage:
        "Hi ha hagut un error a la pujada. Si us plau, intenta-ho més tard",
      activeSpace:
        "S'ha produït un error en activar l'espai, si us plau posa't en contacte amb suport.",
    },
    errorCode: {
      "23bd9dbf-6b9b-41cd-a99e-4844bcf3077f":
        "El correu electrònic ja està en ús.",
      "bd79c0ab-ddba-46cc-a703-a7a4b08de310":
        "No és una adreça de correu electrònic vàlida.",
    },
    apiMessage: {
      EMAIL_FOR_ACTIVATION_SENT:
        "Hem enviat un correu electrònic per completar lactivació.",
      ERROR_TOKEN_NOT_FOUND: "El sistema no troba la invitació per activar",
      ERROR_USER_INVITATION_ACTIVATED_ALREADY:
        "Aquesta invitació ja ha estat activada",
      ERROR_USER_INVITATION_IS_DELETED: "Aquesta invitació ha estat eliminada",
      ERROR_USER_BELONG_SPACE_ALREADY:
        "Aquest usuari ja pertany a aquest espai",
      ERROR_GUEST_USER_ARE_NOT_ALLOWED_TO_USE_USER_INVITATION:
        "Els usuaris convidats no poden utilitzar la invitació d'usuari",
      ERROR_YOUR_USER_IS_BEING_CREATED_TRY_AGAIN:
        "El teu usuari s'està creant. Torna a prémer l'enllaç del correu electrònic en uns segons",
      ERROR_INVITATION_HAS_EXPIRED: "Aquesta invitació ha expirat",
      ERROR_SPACE_IS_DELETED: "L'espai ha estat esborrat",
      "name is required": "Es requereix el nom",
      ERROR_SPACE_ACTIVATED_ALREADY: "Aquest espai ja ha estat activat.",
      ERROR_SPACE_IS_BEING_CREATED_TRY_AGAIN:
        "S'està creant l'espai. Fes clic a l'enllaç d'activació en uns segons",
      ERROR_SUPER_ADMIN_CANNOT_BE_INVITED: "Superadmin no pot ser convidat",
      SUPER_SPACE_NAME_EXISTS: "Ja hi ha un super espai amb aquest nom",
    },
  },
  status: {
    available: "Disponible",
    availableMessage: "Compte! Podran trucar-te sense avisar",
    busy: "Ocupat",
    call: "Sonar al trucar",
    callMessage:
      "La teva càmera i àudio estaran apagats quan rebis una trucada",
    noStatus: "Sense estat",
    offline: "Desconnectat",
    vacation: "De vacances",
    reasons: {
      reason: "Motiu",
      eating: "Menjant",
      resting: "Descansant",
      focused: "Concentrat",
      call: "En una trucada",
      vacation: "De vacances",
      anotherReason: "Un altre motiu",
    },
  },
  actions: {
    avatar: "Avatar",
    chat: "nubi xat",
    exit: "Sortir",
    logout: "Tancar sessió",
    workInOffice: "Estic a l'oficina",
    manageSpaces: "Gestionar espai",
    manageCampus: "Gestionar campus",
    profile: "El meu perfil",
    sendConsoleMessage: "Enviar anunci general",
    videoCallSettings: "Configuració de videotrucada",
    support: "Suport / Ajuda",
    multiplayerToolKit: "Power-ups",
    config: "Configuració",
    utilities: "Utilitats",
  },
  auth: {
    welcome: "Benvingut",
    forgot: "Has oblidat la teva contrasenya?",
    backToLogin: "Tornar al login",
    forgotTitle: "Sol·licitar canvi de contrasenya",
    resetTitle: "Ingressa la teva nova contrasenya",
    pinlink: "Accedir amb un PIN que enviem al teu email.",
    pinTitle: "Sol·licitar PIN d'accés.",
    pinLoginTitle: "Accedir amb PIN.",
    pintDescription: "Escriu el teu correu associat al compte de nubi.",
    welcomeGicar: "Accés amb credencials corporatives (Gicar)",
  },
  manageSpaces: {
    sidebar: {
      users: "Usuaris",
      manageUsers: "Gestionar usuaris",
      inviteUsers: "Convidar usuaris",
      pendingUsers: "Usuaris pendents",
      space: "Espaci",
      customizeSpace: "Personalitzar",
      customizeRooms: "Gestionar sales",
      wonderPoints: "WonderPoints",
      campusSpaces: "Espais del campus",
      spaceSettings: "Configuració",
      multiSpace: "Campus",
      customizeMultiSpace: "Personalitzar",
      settingsMultiSpace: "Configuració",
      manageUsersSuperSpace: "Gestionar els usuaris del campus",
      goToCampus: "Anar al campus",
      announcements: "Anuncis",
      announcementsCampus: "Anuncis del campus",
      announcementsSpace: "Anuncis dels espais",
      posters: "Gestionar cartells",
    },
    customizeSuperSpace: {
      logoImage: "Logotip del campus",
      uploadLogoImage:
        "Aquesta imatge correspon al logotip que veuran els usuaris a la ciutat.",
      changeWebinarType:
        "Estàs segur de canviar el tipus de webinar de l'espai, això podria afectar al webinar en curs",
    },
    customizeSpace: {
      warningOpenUrl: "Avís, no totes les URL es poden obrir dins de nubi",
      openUrlExternally: "Obre automàticament en una pestanya nova.",
      selectScene: "Selecciona l'espai",
      logoImage: "Logotip de l'espai",
      uploadLogoImage:
        "Aquesta imatge correspon al logotip que veuran els usuaris al menú.",
      uploadBackgroundImage:
        "Aquesta imatge s'utilitzarà a la landing que es generarà (en un futur) al crear un espai",
      boardImage: "Cartell de l'entrada",
      uploadBoardImage:
        "Aquesta imatge és la que es mostra al cartell que es troba a la porta principal de l'espai",
      uploadCommonImage:
        "En cas que hi hagi pantalles de sales sense definir, es farà servir aquesta imatge per mostrar-la per defecte",
      roomImage: "Pantalles de la sala",
      uploadRoomImage:
        "Aquesta imatge s'utilitzarà per defecte a totes les pantalles que hi ha a cada sala de l'espai.",
      uploadOneRoomImage:
        "Aquesta imatge es farà servir a la pantalla d'aquesta sala.",

      selectRoom: "Selecciona la sala",
      editRoom: "Edita els valors de la sala",
      selectPoster: "Selecciona el cartell",
      editPoster: "Editar els valors del cartell",
      posterImage: "Imatge del cartell",
      uploadPosterImage: "Aquesta imatge s'utilitzarà al cartell",
      urlPoster: "Enllaç fixat al cartell",
      noPosters: "No hi ha cartells en aquest espai",
    },
    inviteUsers: {
      title: "Hola! Quin tipus d'usuari vols afegir?",
      userDescription:
        "Té correu electrònic i contrasenya.Es requereix registre.Usuari permanent a l'espai",
      guestDescription:
        "No té correu electrònic ni contrasenya.Només de visita.Usuari temporal",
      orShareLink: "O comparteix aquest enllaç",
      addGuidedVisit: "Afegir visita guiada",
      sendInvitations: "Enviar Invitació",
      newInvitation: "Nova invitació",
      withOnboarding: "Onboarding es mostrarà en entrar a l'espai",
      generateNewUrl: "Generar nou enllaç",
      confirmGenerate:
        "Estàs segur de tornar a generar un nou enllaç?, els usuaris no hi podran accedir des de l'enllaç anterior.",
      pendingInvitations: "Invitacions pendents",
      grazingDescription:
        "Tria a quina sala vols que l'usuari vagi automàticament (la primera vegada que iniciï sessió)",
      noGrazing: "Sense visita guiada",
      guestInvitation: "Només com a convidat",
      userInvitation: "nubi Usuari",
      selectLanguage: "Selecciona l'idioma en què s'envia la invitació",
      dateExpiration: "L'invitació caduca el",
    },
  },
  manageUsers: {
    group: {
      groups: "Grups",
      createGroup: "Crear grup",
      editGroup: "Editar grup",
      editUsers: "Editar usuaris"
    },
    table: {
      user: "Usuari",
      email: "Correu",
      enabled: "Habilitat",
      disabled: "Deshabilitat",
      lastConnection: "Última connexió",
      noLastConnection: "Sense última connexió",
      name: "Nom",
      space: "Espaci",
      spaceType: "Tipus d'espai",
    },
    permissions: {
      title: "Permisos",
      canInvite: "Pots convidar més usuaris",
      isAdmin: "Pots administrar l'espai",
      isCampusAdmin: "Pot gestionar el campus",
      isWebinarHost: "És ponent de webinar ",
      isMultiWebinarHost: "Es un ponent del webinar al campus",
      onlyInMultiWebinar: "Només quan el Multiwebinar està actiu",
      globalMessage: "Pots enviar avisos",
      isTrial: "Pràctiques",
      isEmployed: "Usuari",
      canPinChatMessage: "Pots ancorar missatges",
      canBan: "Pots banejar altres usuaris",
      canChangeRoomPin: "Pot canviar el pin d'una sala",
      disableIsAdmin:
        "Per desactivar aquest usuari, no has de ser administrador de l'espai o del campus",
      disableIsCampusAdmin:
        "Per desactivar aquest usuari, no has de ser administrador del campus.",
      canUploadPhoto: "Pot penjar fotos a PowerUps",
      canMuteAndCamera: "Podeu silenciar i apagar càmeres a les sales de reunions",
      canMuteAndCameraInstructions: "Perquè aquest permís tingui efecte ha de sortir i entrar de la sala",
      gobalPermission: "Permisos globals del campus",
      spacePermission: "Permisos globals del campus",
      noGlobalPermission: "No hi ha permisos globals",
      canManageMeetingControl: "You can mute the microphone and turn off cameras during calls",
      canManageWebinar: "You can enable speakers in the webinar",
      rol: "User role",
      showSpotify: "Habilitar Spotify",
    },
    tooltip: {
      webinar: "Té permisos de webinar",
      admin: "És administrador",
      canInvite: "Pot convidar usuaris",
      globalMessage: "Pot enviar avisos",
      canPinChatMessage: "Pot ancorar missatges",
      canBan: "Pot banejar altres usuaris",
      canChangeRoomPin: "Pot canviar el pin d'una sala",
      canUploadPhoto: "Pot pujar fotos a PowerUps",
    },
    filter: {
      none: "No té cap rol especial",
      all: "Tots els usuaris",
      webinar: "És un ponent als webinars",
      admin: "Pot administrar l'espai",
      canInvite: "Pot convidar usuaris",
      globalMessage: "Pot enviar avisos",
      isTrial: "Està en pràctiques/beca",
      disabled: "Usuaris deshabilitats",
      userOnline: "Usuaris connectats",
      canPinChatMessage: "Pot ancorar missatges",
      canBan: "Pot banejar altres usuaris",
      canChangeRoomPin: "Pot canviar el pin d'una sala",
    },
    confirmDelete: {
      title: "Eliminar usuari de l'espai",
      description:
        "Estàs segur d'eliminar aquest usuari?, no podrà tornar a ingressar a aquest espai",
    },
  },
  announcements: {
    addNew: "Crea un nou anunci",
    title: "Títol de l'anunci",
    frequency: "Repetir",
    justOne: "Només una vegada",
    everyHalfHour: "Cada mitja hora",
    everyHour: "Cada hora",
    time: "Enviar a",
    text: "Text de l'anunci",
    timeToSend: "Data d'enviament",
    confirmDelete: {
      title: "Eliminar l'anunci",
      description: "Estàs segur de que vols eliminar aquest anunci?",
    },
    successDelete: "L'anunci s'ha eliminat correctament",
    successCreate: "L'anunci s'ha creat correctament",
    chexboxText: "Repetir aquest anunci tots els {day}",
    text1: "Del campus",
    text2: "De l'espai",
    repeat: "Es repeteix",
    every: "Cada {day}",
    no: "No",
  },
  profile: {
    sidebar: {
      general: "General",
      security: "Seguretat",
      social: "Social",
      logs: "Esdeveniments registre",
      videoAudio: "Configurar dispositius",
      knowledge: "Coneixement",
      curriculum: "Currículum",
    },
    security: {
      veryWeakPassword: "Contrasenya molt feble",
      weakPassword: "Contrasenya feble",
      securePassword: "Contrasenya segura",
      strongPassword: "Contrasenya molt segura",
      differentPassword: "La contrasenya no coincideix",
    },
    confirmUnsubscribe: {
      title: "Eliminar el meu compte nubi",
      checkBoxText: "Eliminar compte",
      description:
        "Segur que vols eliminar el teu compte de nubi? No podràs accedir amb aquest usuari",
    },
  },
  consoleMessage: {
    title: "Nou avís",
    all: "Tots",
    noSound: "Sense so",
    dingDong: "Ding Dong Ding",
  },
  newMessage: {
    title: "Nou missatge directe",
  },
  paperPlane: {
    title: "Nou avió de paper",
  },
  configDevices: {
    videoConference: "nubi té funcions de videoconferència...",
    chooseDevices: "Pots veure't?",
    noPermissions: "Sense accés a micròfon i càmera",
    popupPermissions:
      "Has de donar-nos permisos per fer servir la teva càmera i micròfon",
    allowPermissionsText:
      "Permetre que Google Chrome accedeixi a la meva càmera i micròfon",
    allowPermissions: "Permetre accés",
    skip: "Omet aquesta part",
    skipModal: "Estàs segur? La càmera i micròfon no funcionaran a nubi.",
    clickAllow: 'Fes click a "Permetre" a la finestra emergent del navegador',
    havingIssues: "Tens problemes?",
    browsersStuck:
      "Els navegadors de vegades fallen al capturar la càmera. Per arreglar això",
    refreshPage:
      "Intenta actualitzar la pàgina. Hem modificat la configuració de la càmera perquè sigui més probable que funcioni.",
    checkPermissions:
      "Revisa els permisos de càmera i micròfon al teu explorador",
    help: "Si això no funciona",
    contactUs: "contacta'ns",
  },
  webinarUrlModal: {
    title: "Compartir vídeo al webinar",
    activeWebinar: "Iniciar Webinar",
    description:
      "Pots incloure un enllaç de youtube o vimeo perquè aquest es reprodueixi al webinar o deixar el camp buit si no necessites cap vídeo",
    cancelWebinar:
      "Estàs realment segur de tancar el webinar? totes les persones que estiguin dins, seran desconnectades immediatament",
  },
  otherReasonModal: {
    title: "Indica un altre motiu pel qual estàs ocupat",
  },
  changeSpaceModal: {
    description:
      "Aquests són els espais que tens disponibles i pots visitar. Per anar a un altre espai fes clic sobre el que vulguis a la llista i seràs redirigit automàticament. ",
    active: "Ets aquí",
  },
  confirmBanModal: {
    text: "En expulsar-lo, l'usuari quedarà a més deshabilitat fins que ho canviïs al menú d'usuaris.",
    buttonConfirm: "Confirmar",
    buttonCancel: "Cancel·lar",
  },
  vacationModal: {
    title: "Quan tornes de vacances?",
    label: "Deixa saber als teus companys la data en què tornes a nubi.",
    error: "Selecciona la data de la teva tornada de vacances",
  },
  callErrorModal: {
    title: "Informació",
    text: "Atès que portes una bona estona amb la càmera encesa sense interactuar amb un altre avatar, per privadesa nubi t'ha tret de la sala. Torna a entrar si vols continuar.",
    resetCall: "Reconnectar a la trucada",
  },
  check: {
    checkEmail: "El correu electrònic no és vàlid",
  },
  changeAvatar: {
    title: "Selecciona el teu avatar",
  },
  onBoarding: {
    welcome: {
      welcome: "Benvingut a",
      welcomeDescription:
        "Aquest és el teu espai a la nubi! Connecta amb els teus companys i sentiu-vos junts, sense importar on estigueu. Estàs llest?",
      welcomeDescriptionLine2: "Estàs llest? Esperem que ho gaudeixis!",
    },
    suggestions: {
      noShow: "No tornar a mostrar",
      one: "Per desplaçar-te per nubi, fes doble clic sobre el lloc on vols anar.",
      two: "Pots acostar o allunyar la pantalla per veure tot lespai de nubi sense moure el teu avatar del seu lloc.",
      three:
        "Hi ha certes sales de reunió a nubi on en entrar, la teva càmera i el teu micròfon s'activaran automàticament.",
      four: "Xateja amb altres avatars a través de missatges directes, trucades privades 1:1 o al xat de sala.",
      five: "Si et conviden a dos o més espais de nubi, aquí pots triar quin espai vols visitar i viatjar d'un a l'altre fàcilment.",
      six: "Si fas clic sobre un usuari podràs interactuar-hi i enviar-li avions de paper amb missatges per captar la seva atenció.",
    },
  },
  confirmInvite: {
    inviteUser:
      "Has d'introduir el teu correu, rebràs un correu de confirmació per validar el teu compte i poder ingressar a l'espai.",
    inviteGuest: "Has d'introduir el teu nom abans d'entrar a l'espai.",
    expireOn: " Caduca el ",
  },
  gdpr: "Seguint les recomanacions de",
  gdpr2:
    "T'informem que la informació personal que emplenis serà compartida amb tots els usuaris de l'espai. No emplenis el que no vulguis compartir o escriu-nos a",
  gdpr3: "per eliminar completament el teu compte.",
  loader: {
    loadingData: "Hola!",
    loadingSpaces: "On són les meves claus?",
    loadingUser: "Les he trobat!",
    connectingServices: "Comprovant que tot està bé",
    loadingUsers: "Qui vindrà avui?",
    preparingSpace: "Encenent els llums",
    creatingSspace: "Preparant el cafè",
    checkingSpace: "Avui serà un gran dia",
    connectingRoom: "Unint-te a la sala",
  },
  maintenance: {
    maintenance: "MANTENIMENT",
    maintenanceMessage:
      "Estem fent tasques de manteniment per actualitzar el nostre sistema. El manteniment està previst des de les {start} fins {finish}",
    maintenanceMessageError:
      "Estem fent tasques de manteniment per actualitzar el nostre sistema.",
  },
  webGLContextLost: {
    title: "Alguna cosa ha fallat...",
    content: "Fes clic al botó per recarregar nubi.",
  },
  photonError: {
    title:
      "No ens hem pogut connectar als serveis de nubi. Si us plau, comprova que la teva connexió sigui estable. En cas d'estar sota una xarxa corporativa, és possible que aquest problema sigui degut a un tallafoc. En aquest cas, posa't en contacte amb l'administrador de la xarxa de la teva organització.",
    buttonTitleBegin: "FES CLIC AL BOTÓ",
    buttonTitleEnd: "per conèixer els requisits de xarxa de nubi",
    button: "Requisits de xarxa",
  },
  networkRequirementsTitle:
    "Aquí tens una llista dels ports que nubi pot fer servir:",

  googBye: "Marxes?",
  goodbyeText:
    "Si no has decidit anar-te'n, potser hem sigut nosaltres els que hem detectat que potser t'has oblidat de nubi i et desconnectem perquè altres avatars no et molestin. Si no és així, prem el botó per tornar.",
  placeholder: {
    email: "example@email.com",
    selectTypeSpace: "Selecciona el tipus d'espai",
    selectSpace: "Selecciona l'espai",
    dniOrNie: "DNI o NIE",
  },
  tutorial: {
    step1:
      "Anem a ensenyar-te en tres passos com desenvolupar-te i aprofitar al màxim la teva experiència.",
    step2:
      "1- És hora que et moguis! Fes clic amb el punter de ratolí a terra i torna a fer clic a l'emoji blau de caminar per moure't",
    step3:
      "2- Felicitats! Ara anem a una trucada. Per activar la càmera i el micròfon, simplement entra DINS d'una sala i el micròfon i càmera es configuraran per iniciar una videotrucada amb les persones a la sala!",
    step4:
      "3- Excel·lent! Últim pas, com interactuar amb altres usuaris. FES CLIC a ALEX i veuràs la llista de possibles accions, com xatejar, trucar, enviar un avió de paper, o veure la informació d'un altre usuari, FES CLIC A QUALSEVOL D'ELLS per acabar el tutorial!",
    stepComplete: "Felicitats!",
    tutorialComplete:
      "FANTÀSTIC!!, has completat el tutorial, marxem a nubi... Gaudeix de l'experiència.",
  },
  goodMorning: {
    one: "Treballar dur, una ment positiva i aixecar-se aviat són les claus per tenir un gran dia.",
  },
  invitationsActions: {
    deleteInvitation: "Eliminar invitació",
    increaseInvitation: "Augmentar temps d'expiració",
    descriptionDelete: "Realment vols suprimir aquesta invitació?",
    descriptionIncrease:
      "Realment vols augmentar el temps d'expiració d'aquesta invitació?",
  },
  toolkit: {
    NUBII_TOOLS_MESSAGE_IMAGE_UPLOADED: "{name} ha pujat una nova fotografia.",
    NUBII_TOOLS_MESSAGE_NEW_POLL: "{name} ha afegit una nova enquesta.",
    NUBII_TOOLS_MESSAGE_PPPS_REMINDER:
      "Recorda que avui tens disponible el formulari PPPS.",
  },
  callMenu: {
    background: "Seleccionar fons",
    record: "Gravar trucada",
    blur: "Desenfocar fons",
    walkie: "Clica per parlar (tecla N)",
    noise: "Activar cancel·lació de soroll",
    config: "Configurar dispositius",
    muteAll: "Silenciar a tothom",
    videoOffAll: "Apagar vídeo a tothom",
    video: "Vídeo",
    mic: "Micròfon",
    otherOptions: "Altres opcions",
    resetCall: "Reiniciar la trucada",
  },
  recordGuide: {
    title: "Eina de gravació de nubi.",
    step1: "Fes clic al botó vermell per iniciar la gravació",
    step2:
      "Apareixerà una vista amb la pantalla, finestra o pestanya que desitges gravar, selecciona la que vulguis (preferiblement la pestanya de nubi).",
    step3: "Pots pausar i reprendre la gravació quan vulguis.",
    step4:
      "Fes clic en stop per acabar la gravació i aquesta es descarregarà automàticament al teu explorador.",
    step5: "Et recomanem que et descarreguis",
    step5_2: "per veure els vídeos de nubi",
  },
  callIsRecord: "La trucada està sent gravada",
  recordCall: "Gravar trucada",
  knowledgeRecord: "Enregistrar coneixements",
  knowledgeRecording: "Gravant coneixements",
  knowledgeRecordTitle: "Grava els teus coneixements",
  autoVideo: {
    title: "Per acabar, afegeix un títol, una descripció i guarda, o rebutja si no estàs content amb el resultat i no el vols desar.",
    notSaved: "Si rebutges no es desarà el vídeo",
    decline: "Rebutjar",
  },
  recordingCall: "{name} està gravant la trucada",
  confignubii: {
    call: "Trucada",
    notification: "Notificacions",
    sound: "So",
    disableMic: "Iniciar sempre amb micròfon apagat",
    disableCam: "Iniciar sempre amb càmera apagada",
    volume: "Volum de la trucada",
    silenceNotifications: "Silenciar notificacions",
    silenceReactions: "Silenciar reaccions",
    scene: "Escenari",
    chat: "Xat",
    defaultChatOpen: "Mostra sempre el xat obert en entrar en trucada",
    disableSoundNotification: "Desemmudir notificació",
    activeSendMailChat: "Feu clic per enviar el resum del xat a la final de la sessió.",
    disableSendMailChat: "Feu clic per enviar un resum del xat a la final de la sessió.",
  },
  welcomeModal: {
    title: "Afegeix a més usuaris",
    one: "Hola, Copia aquest enllaç i envia'ls a tots els que vulguis que accedeixin com a usuaris al teu nou espai,",
    two: "o ingressa",
    three: "al menú d'invitacions",
    four: "per veure més opcions",
    url: "Enllaç per a usuaris",
  },
  admin: {
    sidebar: {
      analytics: "Estadístiques",
      goBack: "Tornar enrere",
      dashboard: "Dashboard",
      spaces: "Espais",
      multi_spaces: "Campus",
      users_list: "Usuaris",
      spaces_requests: "Sol·licituds d'espai",
      new_space: "Crear nou espai",
    },
    actions: {
      enabled: "Habilitar espai",
      disabled: "Deshabilitar espai",
      delete: "Eliminar espai",
    },
    confirmDeleteSpace: {
      title: "Eliminar espai",
      description: "Estàs segur d'eliminar aquest espai?",
    },
    confirmDisabledSpace: {
      title: "Deshabilitar espai",
      description: "Estàs segur de deshabilitar aquest espai?",
    },
    request_space: {
      spaceName: "Nom de l'espai",
      creatorEmail: "Correu del creador",
      spaceType: "Tipus d'espai",
      activationUrl: "Enllaç d'activació",
      creationDate: "Data de creació",
    },
    dashboard: {
      welcome: "Benvingut",
      welcomeDescription: "Aquí podràs gestionar tot nubi",
      usersLogin: "Usuaris actius",
      dau: "Usuaris actius diaris",
      wau: "Usuaris actius setmanals",
      mau: "Usuaris actius mensuals",
    },
  },
  webinarModal: {
    title: "Webinar",
    enterWebinarSpan: "ATENCIÓ: ",
    enterWebinar1: "Benvinguts a la sala Webinar",
    enterWebinar2:
      'Aquest és un espai per a WEBINARS. Només els usuaris amb permís de "Ponent" podran activar la seva càmera i micròfon, que estarà desactivat per defecte. Dins de la sala qualsevol "Ponent" podrà convidar altres usuaris a participar',
    cancel: "Cancel·la i marxa",
    accept: "Acceptar i anar a la reunió",
  },
  autoVideoEnterModal: {
    title: "Auto Video",
    enterAutoVideoSpan: "ATENCIÓ: ",
    enterAutoVideo1: "Benvingut a la sala d'Auto Video.",
    enterAutoVideo2:
      "Aquest és un espai per a Auto Video. Dins de la sala podrà gravar coneixements.",
    cancel: "Cancel·lar",
    accept: "Acceptar",
  },
  speedNetworkingModal: {
    title: "Speed Networking",
    connectWith: "Connectat amb",
    nextConnection: "Propera connexió a",
    preparingConnection: "Prepara't per a la teva propera reunió",
    preparingConnectionDescription:
      "Esperant el teu company per iniciar la connexió",
    waitingMoreUsers: "Esperant més usuaris per iniciar les connexions",
    breakTime: "Pren-te un descans mentre preparem la teva propera reunió",
    enterSpeedNetworking1: "Benvingut a la sala de NETWORKING",
    enterSpeedNetworking2:
      "Si prems sobre l'opció de Entrar tindràs vídeotrucades aleatòries amb TOTS els usuaris de la sala. En acabar et connectarem amb un altre avatar i així successivament fins que surtis o els hagis conegut a tots. Quan vulguis deixar de tenir videotrucades simplement surt de la sala de networking.",
    enterSpeedNetworkingSpan: "ATENCIÓ: ",
    enterSpeedNetworking3:
      "Si no vols tenir vídeotrucades amb ningú i no vols conèixer nous usuaris de l'espai ara mateix, CANCEL·LA ara",
  },
  chatMenu: {
    general: "Xat general",
    pinnedMessages: "Missatges ancorats",
    openChats: "Xats oberts",
  },
  userOnlineActions: {
    showProfile: "Veure perfil",
    call: "Trucar",
    chat: "Xat",
    disable: "Deshabilitar",
    enable: "Habilitar",
    goToSpace: "Anar a l'espai",
  },
  messageActions: {
    pinMessage: "Ancorar missatge",
  },
  roomPin: {
    changePin: "Pots assignar un PIN a la sala per fer-la privada",
    enterPin: "Has d'introduir un PIN per entrar a la sala",
    pinNull: "Si deixes el PIN en blanc, la sala serà oberta",
    addPin: "Aplicar el PIN de seguretat",
    removePin: "Alliberar sala",
    errorPin: "El PIN és incorrecte",
    doneChangePin: "El PIN s'ha assignat correctament",
    doneReleaseRoom: "La sala s'ha alliberat correctament",
    doneReleasePin: "Sales alliberades correctament",
    releasePins: "Alliberar totes les sales que tinguin un PIN",
    textfootchangePin: "Aquesta sala està permanentment bloquejada",
    enterPinNotepad: "Has d'ingressar la PIN de la sala",
  },
  spaceType: {
    OFFICE_TYPE: "Oficina",
    EVENT_TYPE: "Esdeveniment",
    EKAM_TYPE: "Espai de meditació",
    LEARNING_TYPE: "Aprenentatge",
    MINISO_TYPE: "Espai Ecommerce",
  },
  sceneType: {
    SMALL: "Petit",
    MEDIUM: "Mitjà",
    LARGE: "Gran",
    AUTOMOTIVE: "Automotive",
    CONFERENCE_CENTER: "Conferència petita",
    CONFERENCE_CENTER_LARGE: "Copnferència gran",
    CONFERENCE_COFFEE: "Cafeteria",
    CONFERENCE_WEBINAR: "Conferència amb Webinar",
    CONFERENCE_WEBINAR_SPEED_NETWORKING:
      "Conferència amb Webinar i Speed Networking",
    FESTIVAL: "Concert",
    LAKE_SINGLE_WEBINAR: "Llac amb Webinar",
    TEMPLE: "Temple",
    MINISO: "Botiga online",
    LEARNING: "Aprenentatge",
    RECREATIVE: "Recreació",
    AUDITORIUM: "Auditori",
    LAKE_SINGLE_WEBINAR_LARGE_WITH_BOOTHS: "Gran llac amb Webinar",
    WEBINAR_SPEED_NETWORKING_PLATFORM:
      "Platforma amb Webinar i Speed Networking",
    OFFICE_PLATFORM_NORMAL: "Plataforma oficina",
    AUDITORIUM_MINI: "Mini Auditori",
    LEARNING_PLATFORM: "Platforma d'aprenentatge",
    GAMING_PLATFORM: "Platforma de gaming",
    OFFICE_PLATFORM_NORMAL_TWO: "CTTI",
    AUDITORIUM_PLATFORM: "Plataforma Auditori",
    HAWKINGS_LARGE: "Large Hawkings",
    SHOWROOM_SMALL: "Showroom small",
    SHOWROOM_VERY_SMALL: "Showroom very small",
    SHOWROOM_NORMAL: "Showroom normal",
    SHOWROOM_LARGE: "Showroom large",
    SHOWROOM_BIG: "Showroom big",
    SHOWROOM_SUPER_BIG: "Showroom super big",
    SHOWROOM_NETWORKING: "Showroom networkings",
    SHOWROOM_SUPER_OFFICE: "Showroom super office",
    SHOWROOM_INVESTIGATION: "Showroom investigation",
    SHOWROOM_SUPER_BIG_WITH_NETWORKING_NO_WALL: "Showroom super big no wall",
    SHOWROOM_FOREST: "Showroom forest",
    SHOWROOM_OASIS: "Showroom oasis",
    SHOWROOM_TROPICAL: "Showroom tropical",
    SPACE_ISLANDS: "Space islands",
    SPACE_ISLANDS_XRF: "Space islands xrf",
    SPACE_ENEB : "Space eneb",
    CTTI_BURRA_CLUB: "La burra club",
    ENEB_SPACE_ISLANDS_BLUE : "Space eneb islands",
    HESPERIDES_ISLANDS: "Hesperides Islands",
  },
  goodbyeUnsubscribe: "Et trobarem a faltar, gràcies per ser part de nubi",
  goToNubiWeb: "Anar al lloc web de nubi per a més informació",
  openLink: "Obrir enllaç",
  posterRedirect:
    "Aquest cartell conté un lloc web d'interès. Si acceptes, seràs redirigit a una pàgina externa de nubi",
  chat: {
    confirmDelete: {
      title: "Netejar xat",
      description:
        "Estàs segur que vols suprimir els missatges del xat general? No podràs veure els missatges d'abans d'aquesta acció",
    },
    userDelete: "Usuari esborrat"
  },
  layoutTypes: {
    COLUMN: "Columna única",
    GRID: "Graella",
    COLUMN_LEFT: "Columna a l'esquerra",
    // COLUMN_RIGHT = "COLUMN_RIGHT",
    COLUMN_TRANSPARENT_LEFT: "Columna a l'esquerra",
    TOP_ROW: "Top row",
    TOP_SHARE: "Compartir gran",
  },
  callModal: {
    title: "t'está trucant",
    restart: "Estàs segur que vols reiniciar la trucada ?",
  },
  chatContent: {
    today: "Avui",
    yesterday: "Ahir",
  },
  configurationSuperSpace: {
    titleButton: "Afegiu IP per comprovar automàticament si els usuaris són a l'oficina o a casa",
    from: "Des de",
    to: "Fins",
    range: "Rang",
    no: "No",
    yes: "Si",
    textCheckBoxFalse: "Marca per afegir IP per rang",
    textCheckBoxTrue: "Desmarca per afegir IP",
    ipNoValid: "IP no valida",
    alreadyExists: "Ja existeix la IP",
    rangeAlreadyExusts: "Ja existeix el rang d'IPS",
    rangoMax: "La IP final no pot ser menor que la inicial",
    confirmDelete: {
      title: "Eliminar IP",
      description: "Segur que suprimiu aquesta IP?",
    }
  },
  languages: {
    en: "Anglès",
    ca: "Català",
    zk: "Xinès mandarí",
    hi: "Hindi",
    es: "Espanyol",
    fr: "Francès",
    ar: "Àrab",
    ru: "Rus",
    pt: "Portuguès",
    id: "Indonèsi",
    de: "Alemany",
    ja: "Japonès",
    tr: "Turc",
    ko: "Coreà",
    it: "Italià",
  },
  birthdayModal: {
    title: "Avui és l'aniversari de {name}!",
    congratulateBirthday: "Feliç Aniversari!",
    birthdayMessage1: "Moltes felicitats, gaudeix molt del teu dia! ",
    birthdayMessage2: "Felicitats, gaudeix, t’ho mereixes!",
    birthdayMessage3: "Felicitats, un any més jove!",
    birthdayMessage4: "Un any més donant guerra!",
    birthdayMessage5: "Per molts més anys!",
  },
  favouriteSpace: {
    campus: "Campus",
    favouriteSpace: "Espais favorits",
    modalFavouriteSelector: {
      title: "Espais favorits",
      noFavourite: "No tens espais preferits",
    }
  },
  callContentComponent: {
    waiting: "Connectat. Esperant els presentadors...",
  },
  eventCalendarComponent: {
    empty: "No hi ha cap esdeveniment programat",
  },
  codeErrorApi: {
    ERROR_ROOM_INVALID_PIN: "PIN no vàlid",
  },
  loginMicrosoft: {
    loading: "Identificant..."
  },
  floatingMenu: {
    poll: "Enquesta",
    notepad: "Bloc de notes"
  },
  poll: {
    vote: "Votar",
    endPoll: "Eliminar enquesta",
    pollEnded: "Finalitzar enquesta",
    currentPoll: "Enquesta actual",
    createNewPoll: "Crear una nova enquesta",
    question: "Pregunta",
    responses: "Respostes (Mínim 2)",
    duration: "Durada",
    pollSuccessNotifications: "Enquesta creada amb èxit",
    confirmCancelPoll: "Esteu segur d'eliminar l'enquesta?",
  },
  robot: {
    helpYou: "Hola sóc {name}. En què puc ajudar-te?",
    questionHere: "Escriu aquí la teva pregunta",
    sendQuestion: "Enviar pregunta",
    waitingResponse: "Esperant resposta",
    aiNotAvailable: "En aquests moments, la intel·ligència artificial no està disponible",
  },
  register: {
    activeUser: "Welcome to Hawkings, check your mail.",
    registeredUserError: "The user is already registered",
    activationAlreadyDone: "Activation has already been done",
    country: "Country",
    registerHere: "Don't have an account? Register here",
    register: "Sign Up",
    termsAndConditions1: "By proceeding, you acknowledge and accept our",
    termsAndConditions2: "Terms and Conditions",
    termsAndConditions3: "and",
    termsAndConditions4: "Privacy Policy",
    back: "Go back to the start",
    name: "Name",
    yourName: "Your name",
    lastName: "Last name",
    yourLastName: "Your last name",
    emailAddress: "Email address",
    emailAddressExample: "your@mail.com",
    select: "Select",
    password: "Password",
    yourPassword: "Your password",
    confirmYourPassword: "Confirm your password",
    passwordConfirmation: "Password confirmation",
  },
  education: {
    selectRole: "Select the role",
    teacher: "Teacher",
    student: "Student",
    staff: 'Staff',
    teacherTooltip: 'Restricted access to specific spaces and rooms. Cannot moderate or access teacher tools.',
    studentTooltip: 'Access to educational tools, can moderate rooms, and has the ability to add educational content.',
    staffTooltip: 'Limited access to administrative tools, can moderate, and has permissions to add or remove users in a specific space.',
    superAdminTooltip: 'Full control over all aspects of the campus, including role and permission administration.',
  },
  hawkings: {
    questionHere: "Your message",
    sendQuestion: "Send message",
    newConversation: "+ New conversation",
    examGenerator: "Exam Generator",
    examGeneratorDescription: "This tool assists you in the creation of exams, tailoring them to the level and needs of each group of students. For instance, how would you create an exam to assess basic math knowledge in elementary school children? And how would you design a test for an advanced physics course? The app streamlines this process, ensuring fair and balanced assessments.",
    educationLaw: "Education Law",
    selectEducationalLaw: "Select an education law",
    subjects: "Subjects",
    selectSubject: "Select a subject",
    educationalProgram: "Educational program",
    questions: "Questions",
    numberQuestions: "Number of questions",
    additionalComments: "Additional comments",
    anyAdditionalInstructions: "Any additional instructions for generating the exam",
    language: "Language",
    selectLanguage: "Select a language",
    generateButton: "Generate",
    untitledDocument: "Untitled document...",
    deleteButton: "Remove",
    download: "Download",
    copyToClipboard: "Copy to clipboard",
    examCopiedClipboard: "Exam copied to the clipboard",
    course: "Course",
    selectCourse: 'Select a course',
    tools: "Tools",
    chatBot: "Chatbot",
    clearInputs: "Clear Inputs",
    example: "Example",
    messageCopiedClipboard: "Copied to clipboard",
    clickSelectAssistant: "Fes clic per seleccionar l'assistent",
  },
  CTTI: {
    questionGameModalText: "Vols jugar?",
    spotyfyModal: {
      title: "Vols escoltar la llista de reproducció seleccionada aquesta setmana?",
      openWeb: "Obrir des de la web",
      openApp: "Obrir des de l'aplicació",
      addList: "Afegeix la teva llista de reproducció",
      addTitle: "Com copiar la URL de la llista que vols compartir de Spotify, des de la web",
      addTitle1: "aquí",
      addTitle2: "i des de l'aplicació",
      tutorial: "Fes clic en els tres punts - Compartir - Copiar enllaç de la llista, després enganxa'l al contenidor i afegeix",
      add: "Afegir",
      sidebarListToMusic: "Escoltar música",
      listOf: "La llista seleccionada és de",
      close: "Tancar",
    },
    calendar: {
      calendarTitle: "Calendari",
    },
    reservationRoom: {
      reserveVirtualRooms: "Reserva sala virtual",
      toReserve: "Reservar",
      created: "Creat per",
      room: "Sala",
      of: "Des de les",
      to: "Fins a les",
      roomNoName: "Sala sense nom",
      title: "Títol",
      shortDescription: "Descripció curta",
      selectTheRoom: "Selecciona la sala",
      selectTheReservationTime: "Selecciona l'hora de reserva",
      invalidRange: "Rang no vàlid",
      reservedHours: "Hores reservades",
      selectTheUsersYouWantToInvite: "Selecciona els usuaris que vols convidar",
      selectedUsersToInvite: "Usuaris seleccionats per convidar",
      inviteExternalUsersWithYourEmail: "Convida usuaris externs amb el seu correu",
      editReservation: "Editar reserva",
      accessPin: "PIN d'accés",
      reserveVirtualRoom: "Sala virtual",
      reservePhysicalRoom: "Sala física",
      description: "Descripció",
      googleMeet : "Google Meet",
      signOut: "Tancar sessió",
      signInGoogle: "Iniciar sessió amb Google",
      signInHotmail: "Iniciar sessió amb Hotmail",
    },
    reservationsPhysicalRoom: {
      reserveVirtualRooms: "Reserve a physical room",
      selectPlant: "Selecciona la planta",
      selectRoom: "Selecciona la sala",
    },
  },
  gameKiller: {
    answers1: "En un gir dramàtic dels esdeveniments, els jugadors han localitzat i desafiat el zombi {data}, assegurant la seguretat de tots. Felicitats per un joc ben jugat!",
    answers2: "El silenci cobreix l'escenari... El zombi {data} ha triomfat en l'ombra, reclamant la victòria sobre tots. Millor sort la pròxima vegada.",
    answers3: "Després d'un intens debat, la decisió és unànime: ningú serà expulsat aquesta ronda. La tensió augmenta mentre el joc continua.",
    answers4: "Després de la votació, {data} va ser expulsat, segellant el seu destí entre planys. La veritat es revela amarga; era innocent, i la seva partida només deixa més preguntes sense resposta.",
    report: "Informar",
    title: "Joc del Zombi",
    eliminated: "Infectats",
    minimize: "Minimitzar",
    information: "Informació",
    vote: "Votar",
    titleReport: "Selecciona un usuari i escriu un breu text sobre per què creus que aquest jugador hauria de ser eliminat",
    selectUser: "Seleccionar usuari",
    textRepor: "Text breu explicant per què s'ha d'eliminar",
    sendReport: "Enviar informe",
    titleVote: "Votació per eliminar a {data1}, informa {data2} amb el següent missatge: {data3}",
    yes: "Sí",
    no: "No",
    resultWaiting: "Esperant resultat",
    sendVote: "Enviar vot",
    titleActive: "El joc del Zombi està actiu",
    tutorial1Title: "Descripció general",
    tutorial1: "Aquest és un joc on els participants es troben en un escenari misteriós en què un d'ells és designat com a zombi. L'objectiu del joc és descobrir la identitat del zombi abans que aquest aconsegueixi infectar a tots els altres participants. Al llarg de la partida, els jugadors hauran d'utilitzar la seva astúcia i intuïció per sobreviure i resoldre el misteri.",
    tutorial2Title: "Com jugar sent el zombi",
    tutorial2: "Si resultes ser el zombi, tindràs la capacitat d'infectar els teus companys. Això es realitza fent clic en un usuari específic. Si en fer clic et apareix una icona de xeringa, significa que tens la possibilitat d'infectar a aquest jugador. Has de procedir amb cautela: en fer clic en la icona de la xeringa, t'acostaràs furtivament al teu objectiu, i un cop estiguis prou a prop, l'infectaràs. Els jugadors infectats seran identificables per una icona distintiva sobre el seu cap. És important recordar que, si has estat infectat, quedaràs fora de joc, incapaç d'informar o comunicar als altres jugadors qui va ser el teu infectador.",
    tutorial3Title: "Com informar el zombi",
    tutorial3: "Si sospites qui pot ser el zombi, o si estàs convençut de la seva identitat, tens l'opció de senyalar-lo mitjançant un botó específic per a realitzar denúncies. Després d'usar aquest botó, s'activarà un període de refredament que t'impedirà fer una altra denúncia immediatament. Has de triar el jugador que creus que és el zombi i proporcionar una explicació concisa de les teves sospites. Això iniciarà una votació amb una durada preestablerta, permetent que els altres jugadors votin a favor o en contra de l'acusació. Si la votació conclou afirmativament i l'acusat resulta ser el zombi, tots els jugadors guanyen. No obstant això, si la votació acaba amb l'eliminació d'un innocent, i tu vas ser qui va fer la denúncia, no podràs denunciar un altre jugador durant les següents 48 hores, i el joc continuarà sense el jugador eliminat. Si la votació és negativa, el joc continua normalment sense afectar l'acusat. El zombi es declara guanyador si aconsegueix infectar la resta dels jugadors sense ser descobert.",
    tutorial4Title: "Com jugar si no ets el zombi",
    tutorial4: "Si no ets el zombi, el teu objectiu serà sobreviure i col·laborar amb els altres jugadors per identificar el culpable. Mantingues alerta davant els comportaments sospitosos, utilitza el botó d'informe amb prudència, i participa activament en les discussions i votacions. Recorda, el teu instint i habilitat per deduir seran claus per desemmascarar el zombi abans que sigui massa tard.",
    zombie: "Zombi",
    Innocent: "Innocent",
    blockDelete: "No pots infectar mentre la votació estigui activa",
    blockKillerDelete: "Has d'esperar {data} abans de poder continuar amb l'eliminació",
    howToPlay: "Com es juga",
    infected: "Infectat",
    lastDead: "Últim infectat {data}",
    gameDiary: "Diari de joc",
  },
  usersGround: {
    groups: "Grups",
    createGroups: "Crear grup",
    editGroup: "Editar grup",
    editUsers: "Editar usuaris"
  },
  level: {
    NATIVE: "Natiu",
    LOW: "Baix",
    MEDIUM: "Mitjà",
    HIGH: "Alt"
  },
  gender: {
    ML: "Masculí",
    FM: "Femení",
    OTHER: "Altres",
    NONE: "Deixar en blanc"
  },
  plans: {
    premium: "Premium",
    title: "Descobreix el Pla Premium: Porta la teva experiència al següent nivell!",
    description: "Estàs preparat per gaudir del millor que la nostra pàgina web té per oferir? Amb el Pla Premium, desbloquejaràs una sèrie de beneficis exclusius dissenyats per oferir-te més valor, comoditat i avantatges que mai.",
    seeBenefits: "Veure Beneficis",
    hirePlan: "Subscriu-te al Pla",
    maxSimultaneusConnections: "S'ha arribat al màxim de connexions simultànies. Si us plau, espereu que hi hagi un espai disponible.",
    "features": {
      "UserLink": "Enllaç d'Usuari",
      "UserLinkDescription": "Genera un enllaç d'invitació per a qualsevol persona que vulguis que sigui un usuari recurrent del teu espai.",
      "GuestLink": "Enllaç de Convidat",
      "GuestLinkDescription": "Genera un enllaç d'invitació per a qualsevol persona que vulguis que sigui un convidat puntual al teu espai.",
      "FavoriteSpace": "Espai Preferit",
      "FavoriteSpaceDescription": "Marca els teus espais preferits.",
      "SearchFilters": "Filtres de Cerca",
      "SearchFiltersDescription": "Filtra per coneixement, experts en matèries i projectes dins del teu grup d'usuaris.",
      "UserListRolls": "Rol de la Llista d'Usuaris",
      "UserListRollsDescription": "Mostra el lloc de treball de cada usuari.",
      "UserProfile": "Perfil d'Usuari",
      "UserProfileDescription": "Perfil complet amb tota la informació de cada usuari.",
      "GeneralChat": "Xat General",
      "GeneralChatDescription": "Xat general per a tots els usuaris que són dins de l'espai.",
      "RoomsChat": "Xat de Sales",
      "RoomsChatDescription": "Xat exclusiu per als usuaris dins de cada sala.",
      "PrivateChat": "Xat Privat",
      "PrivateChatDescription": "Xat privat amb qualsevol usuari de l'espai.",
      "Powerups": "Powerups",
      "PowerupsDescription": "Selecció d'eines com registre de tasques, informes setmanals, formularis de vacances, àlbums de fotos, etc.",
      "Reactions": "Reaccions amb o sense So",
      "ReactionsDescription": "Reaccions als xats, amb o sense so (aplaudiments, tambors, etc.).",
      "SpotifyList": "Llistes de Spotify",
      "SpotifyListDescription": "Comparteix llistes de Spotify amb els teus companys.",
      "VirtualRoomBooking": "Reserva Sala Virtual",
      "VirtualRoomBookingDescription": "Reserva sales virtuals a Nubi.",
      "PhysicalRoomBooking": "Reserva Sala Física",
      "PhysicalRoomBookingDescription": "Reserva les sales de la teva oficina física des de Nubi.",
      "CampusSpaces": "Campus amb Diferents Espais",
      "CampusSpacesDescription": "Crea un campus amb múltiples espais dins.",
      "Support": "Suport",
      "SupportDescription": "Escriu directament al suport de Nubi per obtenir ajuda.",
      "DefaultPlace": "Estableix el teu Lloc per Defecte",
      "DefaultPlaceDescription": "Configura el teu lloc predeterminat on apareixeràs cada cop que et connectis.",
      "ChangeStatus": "Canvia el teu Estat",
      "ChangeStatusDescription": "Actualitza el teu estat perquè els altres usuaris el vegin.",
      "WorkFromHome": "Indica si Treballes des de Casa o l'Oficina",
      "WorkFromHomeDescription": "Especifica des d'on estàs treballant: casa o oficina.",
      "CreateResume": "Crea el teu CV i Enllaça les Xarxes Socials",
      "CreateResumeDescription": "Crea el teu currículum al teu perfil i inclou les teves xarxes socials.",
      "CustomAvatars": "Avatars Personalitzats",
      "CustomAvatarsDescription": "Tria i canvia el teu avatar quan vulguis.",
      "CustomSpaces": "Espais Completament Personalitzables",
      "CustomSpacesDescription": "Dissenya i personalitza els espais segons les teves necessitats.",
      "ChoosePet": "Tria la teva Mascota",
      "ChoosePetDescription": "Selecciona una mascota per acompanyar el teu avatar.",
      "Notepad": "Bloc de Notes",
      "NotepadDescription": "Pren notes dins de les sales.",
      "WeblinkPanels": "Panells amb Enllaços Web",
      "WeblinkPanelsDescription": "Inclou enllaços a llocs web o vídeos en panells dins dels espais.",
      "Webinars": "Webinars",
      "WebinarsDescription": "Sales on els usuaris participen com a oients, només veient i escoltant el ponent.",
      "MeetingRooms": "Sales de Reunió",
      "MeetingRoomsDescription": "Trucades on els usuaris poden activar càmera i micròfon.",
      "NetworkingRooms": "Sales de Networking",
      "NetworkingRoomsDescription": "Connecta usuaris a l'atzar en trucades de 2-3 minuts.",
      "ShareScreens": "Comparteix Diverses Pantalles",
      "ShareScreensDescription": "Mostra més d'una pantalla alhora.",
      "RaiseHand": "Aixeca la Mà per Parlar",
      "RaiseHandDescription": "Notifica als altres usuaris que vols parlar o preguntar.",
      "BlurBackground": "Difumina el teu Fons",
      "BlurBackgroundDescription": "Aplica un efecte de desenfocament al teu fons durant les videotrucades.",
      "CustomBackgrounds": "Fons Personalitzats",
      "CustomBackgroundsDescription": "Configura un fons personalitzat per a les teves videotrucades.",
      "NoiseCancellation": "Cancel·lació de Soroll",
      "NoiseCancellationDescription": "Elimina el soroll de fons a les trucades.",
      "TurnOffVideos": "Apaga els Vídeos de Tothom",
      "TurnOffVideosDescription": "Desactiva el vídeo de tots els usuaris a la trucada.",
      "MuteEveryone": "Silencia a Tothom",
      "MuteEveryoneDescription": "Silencia els micròfons de tots els usuaris a la trucada.",
      "BlockPrivateRooms": "Bloqueig de Sales Privades",
      "BlockPrivateRoomsDescription": "Protegeix sales amb un codi d'accés.",
      "ShareVideo": "Comparteix un Vídeo",
      "ShareVideoDescription": "Reprodueix un vídeo dins d'una sala.",
      "CastVote": "Fes una Enquesta",
      "CastVoteDescription": "Crea enquestes per als usuaris connectats.",
      "EventsAgenda": "Agenda d'Esdeveniments",
      "EventsAgendaDescription": "Organitza la dinàmica de l'esdeveniment amb una agenda.",
      "MuteNotifications": "Silencia les Notificacions",
      "MuteNotificationsDescription": "Desactiva les notificacions entrants.",
      "Recording": "Gravació de Reunions",
      "RecordingDescription": "Grava les trucades i conserva-les.",
      "ConcentrationMode": "Mode Concentració",
      "ConcentrationModeDescription": "Amaga el fons de Nubi per concentrar-te en presentacions o trucades.",
      "ChangeCameras": "Canvia el Disseny de les Càmeres",
      "ChangeCamerasDescription": "Modifica la disposició de les càmeres segons la teva preferència.",
      "RobotsRooms": "Sales amb Robots i IA",
      "RobotsRoomsDescription": "Inclou robots d'IA en moviment i bots dins de les sales.",
      "PinMessages": "Fixa",
      "PinMessagesDescription": "Fixa missatges importants o elimina'ls.",
      "Games": "Jocs",
      "GamesDescription": "Funcions d'entreteniment integrades.",
      "GoogleCalendarIntegration": "Integració amb Google Calendar",
      "GoogleCalendarIntegrationDescription": "Sincronitza amb el teu Google Calendar.",
      "OutlookIntegration": "Integració amb Outlook",
      "OutlookIntegrationDescription": "Sincronitza amb el teu Outlook.",
      "TeamsIntegration": "Integració amb Microsoft Teams",
      "TeamsIntegrationDescription": "Connecta amb Microsoft Teams.",
      "DomainName": "Domini Propi",
      "DomainNameDescription": "Utilitza un domini personalitzat amb el teu nom corporatiu.",
      "BookMeetings": "Reserva Reunions",
      "BookMeetingsDescription": "Agenda reunions directament des de la plataforma.",
      "MobileApp": "Aplicació Mòbil",
      "MobileAppDescription": "Disponible per a dispositius mòbils.",
      "BrandWithLogos": "Branding amb Logotips",
      "BrandWithLogosDescription": "Personalitza el teu espai amb els logotips de la teva empresa.",
      "BrandWithNames": "Branding amb Noms de Sales",
      "BrandWithNamesDescription": "Assigna noms personalitzats a cada sala de l'espai.",
      "WalkToAvatar": "Camina Cap a un Altre Avatar",
      "WalkToAvatarDescription": "Dirigeix el teu avatar cap a un altre usuari a l'espai.",
      "SendPaperPlane": "Envia un Avió de Paper",
      "SendPaperPlaneDescription": "Aconsegueix l'atenció d'un altre usuari enviant-li un avió de paper.",
      "KickBanUser": "Expulsa o Bana Usuaris",
      "KickBanUserDescription": "Elimina o restringeix usuaris de l'espai.",
      "SendAnnouncements": "Anuncis Generals",
      "SendAnnouncementsDescription": "Envia missatges a tots els usuaris amb o sense so.",
      "Metrics": "Mètriques",
      "MetricsDescription": "Accedeix a informació estadística dels usuaris de l'espai.",
      "Multiwebinar": "Multiwebinar",
      "MultiwebinarDescription": "Activa webinars simultanis en múltiples espais.",
      "CreateUserGroups": "Crea Grups d'Usuaris",
      "CreateUserGroupsDescription": "Organitza els usuaris en grups.",
      "EventLogs": "Registres d'Esdeveniments",
      "EventLogsDescription": "Consulta registres de connexió i desconnexió.",
      "ScheduledAnnouncements": "Anuncis Programats",
      "ScheduledAnnouncementsDescription": "Deixa missatges o avisos programats.",
      "BusinessCards": "Targetes de Presentació",
      "BusinessCardsDescription": "Genera targetes descarregables amb informació del perfil dels usuaris.",
      "SelfRecording": "Autogravació de Vídeos",
      "SelfRecordingDescription": "Crea vídeos gravats per a altres usuaris.",
      "SSO": "Inici de Sessió Únic (SSO)",
      "SSODescription": "Autenticació centralitzada per accedir a l'espai.",
      "Zumbar": "Zumbar",
      "ZumbarDescription": "Notifica de manera privada un usuari que està cometent un error, sense que els altres se n'adonin.",
      "MaximumConnections": "Màxim de connexions",
      "MaximumConnectionsDescription": "Fins a un màxim de 200 connexions simultànies.",
      "MaximumSpaces": "Màxim d'espais",
      "MaximumSpacesDescription": "Fins a un màxim de 20 espais."
    }
  },
  nationality: {
    "AF": "Afganesa",
    "AX": "Ålandesa",
    "AL": "Albanesa",
    "DZ": "Algeriana",
    "AS": "Samoana Americana",
    "AD": "Andorrana",
    "AO": "Angolenya",
    "AI": "Anguillana",
    "AQ": "Antàrtica",
    "AG": "Antiguana i Barbudana",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Arubana",
    "AU": "Australiana",
    "AT": "Austríaca",
    "AZ": "Azerbaidjanesa",
    "BS": "Bahamiana",
    "BH": "Bahrainiana",
    "BD": "Bangladeixana",
    "BB": "Barbadiana",
    "BY": "Bielorussa",
    "BE": "Belga",
    "BZ": "Belizeña",
    "BJ": "Beninesa",
    "BM": "Bermudiana",
    "BT": "Bhutanesa",
    "BO": "Boliviana",
    "BA": "Bòsnia i Hercegovina",
    "BW": "Botswanesa",
    "BV": "de l'illa Bouvet",
    "BR": "Brasilera",
    "IO": "del Territori Britànic de l'Oceà Índic",
    "BN": "Bruneiana",
    "BG": "Búlgara",
    "BF": "Burkinesa",
    "BI": "Burundesa",
    "KH": "Cambodyana",
    "CM": "Camerunesa",
    "CA": "Canadenca",
    "CV": "Capverdiana",
    "KY": "Caimanesa",
    "CF": "Centreafricana",
    "TD": "Txadiana",
    "CL": "Xilena",
    "CN": "Xinesa",
    "CX": "de l'Illa de Nadal",
    "CC": "de les Illes Cocos",
    "CO": "Colombiana",
    "KM": "Comoriana",
    "CG": "Congolenya",
    "CD": "Congolesa Democràtica",
    "CK": "Cookiana",
    "CR": "Costa-riquenya",
    "CI": "Ivorian",
    "HR": "Croata",
    "CU": "Cubana",
    "CY": "Xipriota",
    "CZ": "Txeca",
    "DK": "Danesa",
    "DJ": "Djiboutiana",
    "DM": "Dominiquenca",
    "DO": "Dominicana",
    "EC": "Equatoriana",
    "EG": "Egípcia",
    "SV": "Salvadorenca",
    "GQ": "Equatoguineana",
    "ER": "Eritrea",
    "EE": "Estòniana",
    "ET": "Etíop",
    "FK": "Malvines",
    "FO": "Feroesa",
    "FJ": "Fijiana",
    "FI": "Finlandesa",
    "FR": "Francesa",
    "GF": "de la Guaiana Francesa",
    "PF": "Polinesiana Francesa",
    "TF": "dels Territoris Australs Francesos",
    "GA": "Gabonesa",
    "GM": "Gambiana",
    "GE": "Georgiana",
    "DE": "Alemanya",
    "GH": "Ghanesa",
    "GI": "Gibraltarenca",
    "GR": "Grega",
    "GL": "Groenlandesa",
    "GD": "Grenadina",
    "GP": "Guadalupenca",
    "GU": "Guamesa",
    "GT": "Guatemalenca",
    "GG": "Guernesiana",
    "GN": "Guineana",
    "GW": "Guineu Bissau",
    "GY": "Guyanesa",
    "HT": "Haitiana",
    "HM": "de l'illa Heard i Illes McDonald",
    "VA": "Vaticana",
    "HN": "Hondurenya",
    "HK": "Hongkonguesa",
    "HU": "Hongaresa",
    "IS": "Islandesa",
    "IN": "Índia",
    "ID": "Indonèsia",
    "IR": "Iraniana",
    "IQ": "Iraqiana",
    "IE": "Irlandesa",
    "IM": "de l'illa de Man",
    "IL": "Israeliana",
    "IT": "Italiana",
    "JM": "Jamaicana",
    "JP": "Japonesa",
    "JE": "Jerseiana",
    "JO": "Jordaniana",
    "KZ": "Kazakhstanesa",
    "KE": "Keniana",
    "KI": "Kiribatiana",
    "KR": "Coreana del Sud",
    "KW": "Kuwaitiana",
    "KG": "Kirguís",
    "LA": "Laosiana",
    "LV": "Letona",
    "LB": "Libanesa",
    "LS": "Lesothense",
    "LR": "Liberiana",
    "LY": "Líbia",
    "LI": "Liechtensteiniana",
    "LT": "Lituana",
    "LU": "Luxemburgesa",
    "MO": "Macauenca",
    "MK": "Macedònia",
    "MG": "Malgaxe",
    "MW": "Malawiana",
    "MY": "Malàisia",
    "MV": "Maldiva",
    "ML": "Maliena",
    "MT": "Maltesa",
    "MH": "Marshallenca",
    "MQ": "Martiniquesa",
    "MR": "Mauritana",
    "MU": "Mauriciana",
    "YT": "Mayottenca",
    "MX": "Mexicana",
    "FM": "Micronesiana",
    "MD": "Moldava",
    "MC": "Monegasca",
    "MN": "Mongolenca",
    "ME": "Montenegrina",
    "MS": "Montserratiana",
    "MA": "Marroquina",
    "MZ": "Moçambiquesa",
    "MM": "Myanmarenca",
    "NA": "Namibiana",
    "NR": "Nauruana",
    "NP": "Nepalesa",
    "NL": "Neerlandesa",
    "AN": "de les Antilles Neerlandeses",
    "NC": "Neocaledònia",
    "NZ": "Neozelandesa",
    "NI": "Nicaragüenca",
    "NE": "Nigeriana",
    "NG": "Nigeriana",
    "NU": "Niuenca",
    "NF": "Norfolkiana",
    "MP": "de les Illes Mariannes del Nord",
    "NO": "Noruega",
    "OM": "Omaní",
    "PK": "Pakistanesa",
    "PW": "Palauana",
    "PS": "Palestina",
    "PA": "Panamenya",
    "PG": "Papú Guinea Nova",
    "PY": "Paraguaiana",
    "PE": "Peruana",
    "PH": "Filipina",
    "PN": "Pitcairnesa",
    "PL": "Polonesa",
    "PT": "Portuguesa",
    "PR": "Porto-riquenya",
    "QA": "Qatarià",
    "RE": "Reunionenca",
    "RO": "Romanesa",
    "RU": "Russa",
    "RW": "Ruandesa",
    "BL": "Saint-barthélemienne",
    "SH": "Santaeleniana",
    "KN": "Saint Kitts i Nevis",
    "LC": "Santa Luciana",
    "MF": "Santmartinenca",
    "PM": "Saint Pierre i Miquelon",
    "VC": "Santvincenç i les Grenadines",
    "WS": "Samoana",
    "SM": "San Marino",
    "ST": "Santomense",
    "SA": "Saudita",
    "SN": "Senegalesa",
    "RS": "Sèrbia",
    "SC": "Seixellesa",
    "SL": "Sierraleonesa",
    "SG": "Singapurenca",
    "SK": "Eslovaca",
    "SI": "Eslovena",
    "SB": "Salomonenca",
    "SO": "Somali",
    "ZA": "Sudafricana",
    "GS": "de Geòrgia del Sud i les Illes Sandwich del Sud",
    "ES": "Espanyola",
    "LK": "Srilankenca",
    "SD": "Sudanesa",
    "SR": "Surinamesa",
    "SJ": "Svalbard i Jan Mayen",
    "SZ": "Suazilandesenca",
    "SE": "Sueca",
    "CH": "Suïssa",
    "SY": "Síria",
    "TW": "Taiwanesa",
    "TJ": "Tadjikenca",
    "TZ": "Tanzaniana",
    "TH": "Tailandesa",
    "TL": "Timoresa",
    "TG": "Togolenca",
    "TK": "Tokelauana",
    "TO": "Tonganesa",
    "TT": "Trinitària i Tobagoniana",
    "TN": "Tunisiana",
    "TR": "Turca",
    "TM": "Turcmenenca",
    "TC": "de les Illes Turks i Caicos",
    "TV": "Tuvaluenca",
    "UG": "Ugandesa",
    "UA": "Ucraïnesa",
    "AE": "Emiratí",
    "GB": "Britànica",
    "US": "Estadunidenca",
    "UM": "Illes Perifèriques Menors dels EUA",
    "UY": "Uruguaiana",
    "UZ": "Usbekistanesa",
    "VU": "Vanuatuana",
    "VE": "Veneçolana",
    "VN": "Vietnamita",
    "VG": "de les Illes Verges Britàniques",
    "VI": "de les Illes Verges dels EUA",
    "WF": "Wallis i Futuna",
    "EH": "del Sàhara Occidental",
    "YE": "Iemenita",
    "ZM": "Zambiana",
    "ZW": "Zimbabwesca"
  }
};
export default ca;
